const VTP_FINANCING_NC = {};
const VTP_FINANCING_UC = {};
const storeMap = { VTP_FINANCING_NC, VTP_FINANCING_UC };
function getFinanceSessionKey(vehicleType) {
    return (vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.toUpperCase()) === 'N' ? 'VTP_FINANCING_NC' : 'VTP_FINANCING_UC';
}
export function readFinance(vehicleType) {
    const storeName = getFinanceSessionKey(vehicleType);
    if (typeof window !== 'undefined') {
        const storageData = sessionStorage.getItem(storeName);
        try {
            return JSON.parse(storageData);
        }
        catch (error) {
            console.error('Failed to parse session storage data', error);
            return null;
        }
    }
    return null;
}
const saveFinancingSession = (vehicleType, payload) => {
    const storeName = getFinanceSessionKey(vehicleType);
    if (typeof window !== 'undefined') {
        sessionStorage.setItem(storeName, JSON.stringify(payload));
    }
    else {
        storeMap[storeName] = Object.assign({}, payload);
    }
};
export function updateFinanceInStore(vehicleId, vehicleType, requestData, result) {
    const financeFromStore = readFinance(vehicleType);
    const financingData = (financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing) ? financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing[vehicleId] : {};
    const obj = {
        financing: Object.assign(Object.assign({}, financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing), { [vehicleId]: Object.assign(Object.assign({}, financingData), { financeRequestData: requestData ? Object.assign({}, requestData) : undefined, financeResponseData: result ? Object.assign({}, result) : undefined }) }),
    };
    saveFinancingSession(vehicleType, obj);
}
export function saveFinanceInStore(vehicleId, vehicleType, financingStore) {
    const financeFromStore = readFinance(vehicleType);
    const financingData = (financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing) ? financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing[vehicleId] : {};
    const obj = {
        financing: Object.assign(Object.assign({}, financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing), { [vehicleId]: Object.assign(Object.assign({}, financingData), financingStore) }),
    };
    saveFinancingSession(vehicleType, obj);
}
export function saveProductInStore(vehicleId, vehicleType, rawProduct, defaultProductData) {
    const financeFromStore = readFinance(vehicleType);
    const financingData = (financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing) ? financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing[vehicleId] : {};
    const obj = {
        financing: Object.assign(Object.assign({}, financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing), { [vehicleId]: Object.assign(Object.assign({}, financingData), { defaultResponse: { Response: rawProduct }, defaultRequest: { Request: financingData.financeRequestData.Request }, defaultProductData }) }),
    };
    saveFinancingSession(vehicleType, obj);
}
